import axios from 'axios';

const getSystemSettingsApi = async (token) => {
  try {
    const res = await axios.get('/Setting/single', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token
        // lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getSystemSettingsApi;
